import {
  IError,
  IValues,
} from '../../../types/interface/Assurance/AssuranceVoyage/resiliation';

export const showErrorValuesDefault = {
  message: false,
};
export const showErrorValuesSubmit = {
  message: true,
};

export const defaultErrorValues: IError = {
  message: '',
};
export const defaultValues: IValues = {
  message: '',
};
